export default class Price {
    constructor(country, locale) {
        this.country = country
        this.locale = locale
    }

    getPriceAndCurrency(price) {
        const currency = this.getCurrency()

        return {
            price: price[currency.toLowerCase()], 
            currency: currency
        }
    }

    getCurrency() {
        if (this.country == "Serbia") return "RSD"
        if (this.locale == "sr") return "RSD"

        return "USD"
    }
}